import React from 'react';
import styles from '../productList.module.scss';
import { KoForm, KoTabs, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
import GeneralInfoCrud from './generalinfo';
import Media from './media';
import Pricing from './pricing';
import Variant from './variant';
import Inventory from './inventory';
import Shipping from './shipping';
// import OrdersAPI from "../../../orders.service";
export default function ProductCurd({initialValues, form,handleSubmit}) {

  // const [formItems, setFormItems] = useState([]);


  // const handleSubmit = useCallback(values => {
  //   let data = form.getFieldsValue();
  //   data['productId'] = formItems;
  //   if(formId === 'create') {
  //     data['formId'] = KoNano('PRO');
  //     data['name']= formData?.name || 'Form';
  //   }
  //   form.setFieldsValue(data);
  //   setIsLoading(true);
  //   OrdersAPI.createProduct(categroyId,subCategroyId, workspaceId,data).then(
  //     (data) => {
  //       setIsLoading(false);
  //       form.resetFields();
  //       KoToast.success(`Form ${formId === 'create' ? 'created' : 'updated'} successfully`);
  //     },
  //     (err) => {
  //       setIsLoading(false);
  //     }
  //   );
  // });

  const panelStyle = {
    marginBottom: 2,
    background: '#fff',
    border: 'none',
    borderRadius: 1
  };

  const HEADER_OPTIONS = [{
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="GeneralInfoOutlined" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="General Information" />
        {/* <KoDescription className={styles.description} text="Details about your business information" /> */}
      </div>
    </div>,
    children:<>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
        <GeneralInfoCrud product={initialValues} form={form}/>
      </KoForm>
    </>
    ,
    key: 1,
    style: panelStyle
  },
  {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="AddGalleryOutlined" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Media" />
        {/* <KoDescription className={styles.description} text="Details about your business profile" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
        <Media form={form}/>
      </KoForm>
    </>,
    key: 2,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="OrderPriceOutlined" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Pricing" />
        {/* <KoDescription className={styles.description} text="Describe about your general preferences" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
        <Pricing/>
      </KoForm>
    </>,
    key: 3,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="QrCodeOutlined" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Inventory" />
        {/* <KoDescription className={styles.description} text="Details about organization  location" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
        <Inventory/>
      </KoForm>
    </>,
    key: 4,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="OrderVarationOutlined" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Variation" />
        {/* <KoDescription className={styles.description} text="Details about organization bank info" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
        <Variant form={form}/>
      </KoForm>
    </>,
    key: 5,
    style: panelStyle
  }, {
    label: <div className={styles.header}>
      <div className={styles.circle}>
        <KoIcon name="LandMarkOutlined" height={20} width={20} />
      </div>
      <div className={styles.title}>
        <KoTitle className={styles.title} level={5} text="Shipping" />
        {/* <KoDescription className={styles.description} text="Details about your tax levied directly" /> */}
      </div>
    </div>,
    children: <>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit}>
        <Shipping/>
      </KoForm>
    </>,
    key: 6,
    fields: 2,
    outof: 5,
    style: panelStyle
  }];


  return (
    <div className={`${styles.formWrapper} profileSection`}>
      <KoTabs options={HEADER_OPTIONS}   />
    </div>
  );
}
